import React from 'react';

function Sprint({ number, name }) {
    return <tr><td>{ number }</td><td>{ name }</td></tr>
}

export default Sprint;